// extracted by mini-css-extract-plugin
module.exports = {"cobrand":"SectionIdentifier_cobrand__tSrFQ"};